// TheatreCreation - ajout

// Import Modules
import React from "react";
import axios from 'axios';
import ElementForm from "./ElementForm";

const myEnv = process.env
const protocole = myEnv.REACT_APP_SERVERPROTOCOLE
const host = myEnv.REACT_APP_SERVERHOSTNAME
const port = myEnv.REACT_APP_SERVERPORT
const apiTheatra = `${protocole}${host}:${port}`

// TheatreCreation Component
const ElementAdd = (params) => {
  const {typeElement} = params
  let objetCourant = {}
  switch(typeElement){
    case 'auteur':
      objetCourant = {
        prenom: ''
        , nom: ''
        , initiales: ''
      }
      break
    case 'theatre':
      objetCourant = {
        site: ''
        , site_antique: ''
        , specifique: ''
        , vestige: ''
        , abreviation: ''
        , lieu_dit: ''
        , type_ed:''
        , localite: ''
        , pres_coord: ''
        , lat:''
        , long:''
        , lat_dec:''
        , long_dec:''
        , geonames_complet:''
        , geonames_texte_fr:''
      }
      break
      case 'user':
      objetCourant = {
        prenom: ''
        , nom: ''
        , email: ''
        , sesame: ''
        , role: ''
      }
      break
    default:
      break
  }



  // onSubmit handler
  const onSubmit = (element) => {
    console.log(" ! Ajout - form commun edit et add")
    delete element.id

    if (element.date_photo) {
      element.date_photo = element.date_photo.length ? element.date_photo : null
    }
    //console.log(element)

    const token = localStorage.getItem('token-access') ? localStorage.getItem('token-access') : ""

    let headers = {
        'accept': 'application/json',
        'x-access-token': token,
    }

    // ! indispensable pour les fichiers
    if (typeElement === 'phototheatre' ) {
        headers['content-type']= 'multipart/form-data'
    }

    //traitement du fichier - je rcupere le fichier
    ///je le stocke et je créer une url pour l'appel que je stocke

    axios({
      method: 'post',
      url:  `${apiTheatra}/${typeElement}`,
      headers: headers,
      data: element
    })

    .then(res => {
      //console.log("Ma reponse")
      //console.log(res)
      if (res.status === 200){
        alert('Element de type ' + typeElement +  ' créé')
        return
      }
      else {
        Promise.reject()
      }
    })
    .catch((erreur) => {
      if (erreur.response.status === 401){
        alert("Une erreur d'authentification a eu lieu lors de la création"
          + " de l'element de type "
          + typeElement
          + " Erreur : "
          + erreur.response.data)
      } if (erreur.response.status === 403){
        alert("Une erreur d'autorisation a eu lieu lors de la création"
          + " de l'element de type "
          + typeElement
          + " Erreur : "
          + erreur.response.data)
      } else {
        alert("Une erreur a eu lieu lors de la création"
          + " de l'element de type "
          + typeElement
          + " Erreur : "
          + erreur.message)
      }
    })
  }

  // renvoie le formulaire
  return(
    <>
    {(typeElement !== 'notice') &&
    <ElementForm
      typeAction="Ajouter"
      initialValues={objetCourant}
      typeElement={typeElement}
      onSubmit={onSubmit}
      />}
      {(typeElement === 'notice') &&
      <h2>Attention  ! pas d'ajout direct de notice, veuillez utiliser Zotero</h2>}
    </>
  )
}

// Export CreateStudent Component
export default ElementAdd